import styled from "@emotion/styled";

export const FlagSVG = styled.svg`
  width: 16px;
  aspect-ratio: 4 / 3;
  vertical-align: middle;
  border: 1px solid #ddd;
`;
